import { render, staticRenderFns } from "./Goclearer.vue?vue&type=template&id=37b6bc11&"
import script from "./Goclearer.vue?vue&type=script&lang=js&"
export * from "./Goclearer.vue?vue&type=script&lang=js&"
import style0 from "./Goclearer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports